import { createContext, useContext, useState } from "react"
import { YEAR_PRESET_ID } from "components/Shared/MultiRangeCalendar/constants"
import { elementsPerGroupFilter } from "../filtersList"
import { CURRENT_YEAR } from "helpers/temporal"
import { FiltersType, ModuleState, RangeCalendar } from "./interfaces"
import {
	FILTERS_DEFAULT_STATE,
	INTERVAL_DEFAULT,
	MODULE_STATE_DEFAULT,
} from "./constants"

interface FiltersContextProps {
	filters: FiltersType
	setFilters: (selectedFilters: FiltersType) => void
	period: string
	setPeriod: (period: string) => void
	interval: RangeCalendar[]
	setInterval: (interval: RangeCalendar[]) => void
	preset: string
	setPreset: (preset: string) => void
	clearFilters: (filterKey?: string) => void
	applyFiltersAction: boolean
	setApplyFiltersAction: (value: boolean) => void
	singleInterval: RangeCalendar[]
	setSingleInterval: (interval: RangeCalendar[]) => void
	singlePreset: string
	setSinglePreset: (preset: string) => void
	moduleState: ModuleState
	setModuleState: (moduleState: ModuleState) => void
}

export const PrepareFiltersContext = () => {
	const [filters, setFilters] = useState<FiltersType>(FILTERS_DEFAULT_STATE)
	const [moduleState, setModuleState] = useState<ModuleState>(
		MODULE_STATE_DEFAULT
	)
	const [applyFiltersAction, setApplyFiltersAction] = useState<boolean>(false)
	const [period, setPeriod] = useState<string>(CURRENT_YEAR)
	const [interval, setInterval] = useState<RangeCalendar[]>(INTERVAL_DEFAULT)
	const [preset, setPreset] = useState<string>(YEAR_PRESET_ID)
	const [singleInterval, setSingleInterval] = useState<RangeCalendar[]>(
		INTERVAL_DEFAULT
	)
	const [singlePreset, setSinglePreset] = useState<string>(YEAR_PRESET_ID)

	const clearFilters = (filterKey?: string) =>
		filterKey
			? elementsPerGroupFilter[filterKey]?.map((key) => (filters[key] = []))
			: setFilters(FILTERS_DEFAULT_STATE)

	return {
		filters,
		setFilters,
		period,
		setPeriod,
		interval,
		setInterval,
		preset,
		setPreset,
		clearFilters,
		applyFiltersAction,
		setApplyFiltersAction,
		singleInterval,
		setSingleInterval,
		singlePreset,
		setSinglePreset,
		moduleState,
		setModuleState,
	}
}

export const FiltersContext = createContext<FiltersContextProps | null>(null)

export const useFiltersContext = () =>
	useContext(FiltersContext) as FiltersContextProps
